import React from "react";
import { Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "2rem",
    lineHeight: "150%",
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
}));

interface SectionTitleProps {
  children: any;
  className?: string;
}

export default function SectionTitle({ children, className }: SectionTitleProps) {
  const classes = useStyles();

  return (
    <Typography component="h2" className={clsx(classes.title, className)}>
      {children}
    </Typography>
  );
}